import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import set from 'lodash/set';
import { getOpenapiInfo, getOpenapiUrl } from '../openapiHelpers';
import { ExpandFormRow, FormRow, CloseButton, Input, Select, Columns, Button, Checkbox, Textarea } from '@here/ref-client-ui';
import './speedCapPerFc.scss';
import utils from 'utils';
import Searchable from '../../../views/shared/searchUtils/Searchable';

const functionalClassSelect = [
    { label: '1', value: '1' },
    { label: '2', value: '2'},
    { label: '3', value: '3' },
    { label: '4', value: '4'},
    { label: '5', value: '5'}
];

class SpeedCapPerFc extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true,
    };
  }

  componentWillUnmount() {
    this.isUnmounted = true;
  }

  componentDidMount() {
    const {
      options: { openapiInfo },
      settings,
      fields: { customizations }
    } = this.props;

    if (openapiInfo) {
      const { urlPath, urlRegex, urlSuffix, keys } = openapiInfo;
      const propsUrl = get(this.props, urlPath);
      const url = getOpenapiUrl(propsUrl, urlRegex, urlSuffix);
      getOpenapiInfo(url, keys, customizations, settings).then((openapiInfo) => {
        if (!this.isUnmounted) {
          this.setState({ openapiInfo });
        }
      });
    }
  }

  getTooltip = () => {
    const {
      options: { tooltip },
    } = this.props;
    let tooltipEl = null;
    const { openapiInfo } = this.state;
    if (tooltip || openapiInfo) {
      tooltipEl = (
        <div className="rf-form-view__tooltip">{tooltip || openapiInfo}</div>
      );
    }

    return tooltipEl;
  };

  onChangeIsPost = (e) => {
    const value = utils.extractData(e);
    const { setFields, options } = this.props;
    const { key } = options;

    setFields({ [`${key}IsPost`]: value });
  }

  onChangeSpeedCapPerFc = (e) => {
    const value = utils.extractData(e);
    const { setFields, options } = this.props;
    const { key } = options;

    try{
        const sp = JSON.parse(value);
        setFields({ [key]: sp });
        this.setState({ isValid: true });
    } catch(e) {
        this.setState({ isValid: false });
    }
  }

  onChange = (i, item, e) => {
    let value = utils.extractData(e);
    const { setFields, fields, options } = this.props;
    const { key } = options;
    const newSpeedCaps = [...fields[key]];
    const newSpeedCap = newSpeedCaps[i];
    if (item === 0) {
        if (value === '') {
          delete newSpeedCap.speed
        } else {
          newSpeedCap.speed = +value;
        }
    } else if (item === 1){
      newSpeedCap.fc = +value;
    }

    setFields({ [key]: [...newSpeedCaps.slice(0, i), newSpeedCap, ...newSpeedCaps.slice(i+1)] });
  }

  onRemoveEntry = (i) => {
    const { setFields, fields, options } = this.props;
    const { key } = options;
    const newSpeedCaps = [...fields[key]];
    newSpeedCaps.splice(i, 1);

    setFields({ [key]: newSpeedCaps.length ? newSpeedCaps : '' });
  }

  onAddEntry = () => {
    const { setFields, fields, options } = this.props;
    const { key } = options;
    const newSpeedCaps = [...(fields[key]||[])];
    newSpeedCaps.push({ fc: 1 });

    setFields({ [key]: newSpeedCaps });
  }

  getSpeedCapEle = (speedCaps, showPost) => {
    const { isValid } = this.state;
    if (showPost) {
        return <Textarea
            value={JSON.stringify(speedCaps)}
            onBlur={this.onChangeSpeedCapPerFc}
            isValid={isValid}
        />
    }
    const speedCapsArray = Array.isArray(speedCaps) ? speedCaps : [];
    const speedCapEntries = speedCapsArray.map((entry, i) => {
        const { speed, fc } = entry;
        return <Columns key={i}>
            <Input
                className={'rf-speedcap-speed'}
                label='Speed'
                placeholder='Speed (min 1, max 70)'
                value={speed}
                onBlur={this.onChange.bind(this, i, 0)}
                type="number"
                min="1"
                max="70"
                blurOnEnter
            />
            <Select
                className={'rf-speedcap-fc'}
                label='Functional Class'
                options={functionalClassSelect}
                value={fc+''}
                onChange={this.onChange.bind(this, i, 1)}
            />
            <Input
                className={'rf-speedcap-placeholder'}
                label='Speed'
            />
            <CloseButton className="rf-speedcap-close-button" onClick={this.onRemoveEntry.bind(this, i)} />
        </Columns>
    });

    return (
        <FormRow key={'param.key'}>
            {speedCapEntries}
            <FormRow>
            <Button
                title="Add Entry"
                onClick={this.onAddEntry.bind(this, 'param.key')}
            />
            </FormRow>
        </FormRow>
    )
  }

  render() {
    const {
      options: { label, key, isExpanded, onlyPost },
      fields,
    } = this.props;
    const speedCap = fields[key] || [];
    const showPost = !!fields[`${key}IsPost`];
    return (
    <Searchable searchKey={key}>
        <ExpandFormRow
            label={label}
            isExpanded={isExpanded}
            tooltip={this.getTooltip()}
            tooltipPlacement="right"
        >
            <Checkbox
                label={onlyPost ? "Text" : "Is POST"}
                isChecked={showPost}
                onChange={this.onChangeIsPost}
            />
            {this.getSpeedCapEle(speedCap, showPost)}
        </ExpandFormRow>
    </Searchable>
    );
  }
}

SpeedCapPerFc.propTypes = {
  fields: PropTypes.object,
  options: PropTypes.object,
  setFields: PropTypes.func.isRequired,
  setNotification: PropTypes.func.isRequired,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  parseUrl: ({ parsedParams, options, postData = {} }) => {
    const res = {};
    const { key}  = options;
    const keyLowerCase = key.toLowerCase();
    if (parsedParams[keyLowerCase] != null) {
        const speedCaps =  parsedParams[keyLowerCase].split(',');
        res[key] = speedCaps.map(speedCap => {
            const [ speed, fc ] = speedCap.split(';');
            return {
                speed,
                fc
            }
        })
        res[`${key}IsPost`] = false;
        delete parsedParams[keyLowerCase];
    } else if (get(postData, key, []).length > 0) {
      res[key] = get(postData, key, []);
      res[`${key}IsPost`] = true;
    }

    return res;
  },

  defaultState: (options) => ({
    [options.key]: options.initValue,
  }),

  getRequestOptions: (fields, options) => {
    const { key, onlyPost }  = options;
    const params = {};
    if (fields[key]) {
      if (fields[`${key}IsPost`] || onlyPost) {
        const data = {};
        params.method = 'post';
        set(data, key, fields[key]);
        params.data = data;
        return params;
      } else {
        const speedCaps = fields[key];
        const speedCapsParam = speedCaps.map(speedCap => {
            return `${speedCap.speed}`;
        })
        set(params, key, speedCapsParam.join(','));
      }
    }
    return {params};
  },

  Component: SpeedCapPerFc,
};
